import React, { useEffect, useState } from "react";
import "./DashBoard.css";
import {
    Box,
    Avatar,
    CircularProgress,
    Divider,
    Grid2,
    LinearProgress,
    linearProgressClasses,
    Stack,
    Step,
    StepLabel,
    Stepper,
    styled,
    Typography,
    StepConnector,
    stepConnectorClasses,
    useTheme,
    Button,
    Card,
    IconButton,
    CardContent,
    Snackbar,
} from "@mui/material";
import { API_courseURL, API_LoginURL } from "../../../../config";
import { API_BannerURL } from "../../../../config";
import { Link, Navigate, Outlet, useNavigate } from "react-router-dom";
import quizOne from "./quizOne.png";
import leaderboardOne from "./leaderboardOne.png";
import leaderboardTwo from "./leaderboardTwo.png";
import leaderboardThree from "./leaderboardThree.png";
import leaderboardFour from "./leaderboardFour.png";
import leaderboardFive from "./leaderboardFive.png";
import projects2 from "./projects2.png";
import projects3 from "./projects3.png";
import projects1 from "./projects1.png";
import SideBar from "../Sidebar/SideBar";
import profile from "./profile.png";
import bronze from "./bronze.png";
import silver from "./silver.png";
import gold from "./gold.png";
import platinum from "./platinum.png";
import legendary from "./legendary.png";
import ProfileBar from "../Profilebar/ProfileBar";
import student from "./student.png";
import girlStudent2 from "./girlStudent2.png";
import girlStudent3 from "./girlStudent3.png";
import girlStudent4 from "./girlStudent4.jpg";
import girlStudent5 from "./girlStudent5.png";
import student2 from "./student2.jpg";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import {
    useGetAssignmentMasterMutation,
    useGetBadgesMutation,
    useGetBannerMasterMutation,
    useGetCourseMasterMutation,
    useGetPointsMutation,
    useGetProjectMasterMutation,
    useGetProjectSubmissionMutation,
    useGetQuizMasterMutation,
    useGetUserInfoMutation,
} from "../../../../apiSlice";
import MuiAlert from "@mui/material/Alert";
import { useParentalInfoCheck } from "../../../context/ParentalInfoCheck";

const DashContent = ({
    setAssignmentData,
    setCourseData,
    setQuizData,
    setProjectData,
    setBannerData,
    assignmentData,
    courseData,
    quizData,
    projectData,
    bannerData,
}) => {
    const theme = useTheme();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState();
    const [earnedPoints, setEarnedPoints] = useState(0);
    const [badgeImages, setBadgeImages] = useState([]);
    const [ProjectsData, setProjectsData] = useState([]);

    // for testing only
    console.log("ProjectsData ========", ProjectsData);

    const { isParentInfoPresent, snackbarOpen, setSnackbarOpen } =
        useParentalInfoCheck();

    const [studentProjectDataAPI] = useGetProjectSubmissionMutation();

    const [studentDataAPI] = useGetUserInfoMutation();
    const [studentPointsAPI] = useGetPointsMutation();
    const [studentBadgesAPI] = useGetBadgesMutation();

    const [studentAssignmentMasterAPI] = useGetAssignmentMasterMutation();

    const [studentCourseMasterAPI] = useGetCourseMasterMutation();

    const [studentQuizMasterAPI] = useGetQuizMasterMutation();
    const [studentProjectMasterAPI] = useGetProjectMasterMutation();
    const [studentBannerMasterAPI] = useGetBannerMasterMutation();
    const leaderboardImages = {
        1: leaderboardOne,
        2: leaderboardTwo,
        3: leaderboardThree,
        4: leaderboardFour,
        5: leaderboardFive,
    };
    const ProjectsImages = {
        1: projects1,
        2: projects2,
        3: projects3,
    };
    const badgeObj = [
        {
            comp: bronze,
            name: "Bronze Badge",
            points: 0,
        },
        {
            comp: silver,
            name: "Silver Badge",
            points: 750,
        },
        {
            comp: gold,
            name: "Gold Badge",
            points: 1500,
        },
        {
            comp: platinum,
            name: "Platinum Badge",
            points: 2000,
        },
        {
            comp: legendary,
            name: "Legendary Badge",
            points: 2200,
        },
    ];

    // Custom hook for fetching leaderboard data with authorization
    const useLeaderboardData = () => {
        const [leaderboardData, setLeaderboardData] = useState([]);

        const [loading, setLoading] = useState(true);
        const [error, setError] = useState(null);

        useEffect(() => {
            setTimeout(() => {
                const fetchLeaderboard = async () => {
                    try {
                        // Get the authorization token from wherever it's stored in your app
                        const token =
                            localStorage.getItem("token") ||
                            sessionStorage.getItem("token");

                        const response = await fetch(
                            `${API_LoginURL}Dashboard/TopFiveStudent`,
                            {
                                method: "GET",
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: `${token}`, // Include the authorization token
                                },
                            }
                        );

                        if (!response.ok) {
                            throw new Error(
                                `Failed to fetch leaderboard data: ${response.status}`
                            );
                        }
                        const data = await response.json();
                        setLeaderboardData(data);
                        setLoading(false);
                    } catch (err) {
                        setError(err.message);
                        setLoading(false);
                    }
                };

                fetchLeaderboard();
            }, 1000);
        }, []);

        return { leaderboardData, loading, error };
    };

    //custom hook for fetching projects data with auth-Sudeep 4/3/2025
    // const useProjectData = () => {
    //     const [ProjectsData, setProjectsData] = useState([]);
    //     const [loading, setLoading] = useState(true);
    //     const [error, setError] = useState(null);

    //     useEffect(() => {
    //         const fetchProjects = async () => {
    //             try {
    //                 // Get the authorization token from wherever it's stored in your app
    //                 const token = localStorage.getItem('token') || sessionStorage.getItem('token');

    //                 const response = await fetch('http://4.188.88.117:5000/Project/ProjectSubmissionListById', {
    //                     method: 'GET',
    //                     headers: {
    //                         'Content-Type': 'application/json',
    //                         // Authorization: localStorage.getItem("token"),
    //                         'Authorization': `${token}`
    //                     }
    //                 });

    //                 if (!response.ok) {
    //                     throw new Error(`Failed to fetch Projects data: ${response.status}`);
    //                 }

    //                 const data = await response.json();
    //                 if (data && Array.isArray(data)) {
    //                     setProjectsData(data);
    //                 } else {
    //                     setProjectsData([]);
    //                 }
    //                 setLoading(false);
    //             } catch (err) {
    //                 console.error('Error fetching projects:', err);
    //                 setError(err.message);
    //                 setLoading(false);
    //                 setProjectsData([]); // Ensure we have an empty array on error
    //             }
    //         };

    //         fetchProjects();
    //     }, []);

    //     return { ProjectsData, loading, error };
    // };

    //till here
    const {
        leaderboardData,
        loading: leaderboardLoading,
        error: leaderboardError,
    } = useLeaderboardData();
    // const { ProjectsData, loading: ProjectsLoading, error: ProjectsError } = useProjectData();

    const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
        height: 10,
        borderRadius: 5,
        [`&.${linearProgressClasses.colorPrimary}`]: {
            backgroundColor: theme.palette.grey[200],
            ...theme.applyStyles("dark", {
                backgroundColor: theme.palette.grey[800],
            }),
        },
        [`& .${linearProgressClasses.bar}`]: {
            borderRadius: 5,
            backgroundColor: "#F85006",
            ...theme.applyStyles("dark", {
                backgroundColor: "#308fe8",
            }),
        },
    }));

    useEffect(() => {
        const fetchMasters = async () => {
            if (loading) {
                try {
                    setLoading(true);
                    const assignmentMaster = await studentAssignmentMasterAPI();
                    setAssignmentData((prev) => ({
                        ...prev,
                        studentAssignmentMaster: assignmentMaster.data,
                    }));
                    const courseMaster = await studentCourseMasterAPI();
                    setCourseData((prev) => ({
                        ...prev,
                        studentCourseMaster: courseMaster.data,
                    }));
                    const quizMaster = await studentQuizMasterAPI();
                    setQuizData((prev) => ({
                        ...prev,
                        studentQuizMaster: quizMaster.data,
                    }));
                    const projectMaster = await studentProjectMasterAPI();
                    setProjectData((prev) => ({
                        ...prev,
                        studentProjectMaster: projectMaster.data,
                    }));
                    const bannerMaster = await studentBannerMasterAPI();
                    setBannerData((prev) => ({
                        ...prev,
                        studentBannerData: bannerMaster.data,
                    }));
                    const studentData = await studentDataAPI();

                    sessionStorage.setItem(
                        "userClassId",
                        studentData.data[0].classId
                    );

                    setUserData(studentData.data[0]);
                    const points = await studentPointsAPI();
                    setEarnedPoints(points.data);
                    const badge = await studentBadgesAPI();
                    setBadgeImages(badge.data);
                    const projectSubmission = await studentProjectDataAPI();
                    setProjectsData(projectSubmission.data);
                } catch (error) {
                    console.error("Error fetching data:", error);
                } finally {
                    setLoading(false);
                }
            }
        };
        fetchMasters();
    }, [loading]);

    useEffect(() => {
        console.log("PROJECTSDATA ========== ", ProjectsData);
    }, [projectData]);

    useEffect(() => {
        console.log("userData === ", userData);
    }, [userData]);

    console.log("studentData", userData);
    localStorage.setItem("UserID", userData?.userId);

    const ImageStepIcon = ({ active, completed, icon }) => {
        const stepIcons = {
            1: bronze,
            2: silver,
            3: gold,
            4: platinum,
            5: legendary,
        };
        return (
            <div
                style={{
                    width: 50,
                    height: 50,
                    borderRadius: "50%",
                    backgroundColor:
                        active || completed ? "#F85006" : "#e0e0e0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <img
                    src={stepIcons[icon]}
                    alt={`Step ${icon}`}
                    style={{ width: 60, height: 60 }}
                />
            </div>
        );
    };
    const CustomConnector = styled(StepConnector)(({ theme }) => ({
        [`&.${stepConnectorClasses.alternativeLabel}`]: {
            top: 24, // Half of icon height (48/2) to center vertically
        },
        [`& .${stepConnectorClasses.line}`]: {
            height: 1, // Thinner line
            border: 0,
            backgroundColor: "#e0e0e0",
            maxWidth: "60%",
            margin: "0 auto",
        },
    }));
    const [activeStep, setActiveStep] = useState(0);
    useEffect(() => {
        if (earnedPoints >= 2200) {
            setActiveStep(4);
        } else if (earnedPoints >= 2000) {
            setActiveStep(3);
        } else if (earnedPoints >= 1500) {
            setActiveStep(2);
        } else if (earnedPoints >= 750) {
            setActiveStep(1);
        } else if (earnedPoints >= 0) {
            setActiveStep(0);
        }
    }, [earnedPoints]);
    const steps = ["0", "750", "1500", "2000", "2200"];

    function setCourseInternalData(course) {
        sessionStorage.setItem("courseData", JSON.stringify(course));
        navigate("/StudentDashboard/Course");
    }

    const cards = [
        {
            id: 1,
            title: "Rahul Biswas",
            content: "8",
            school: "Mount Litera Zee School- Baharampur",
            image: student,
            acheivement: "Top Performer - Grade 8",
        },
        {
            id: 2,
            title: "Hrishita Ghosh",
            content: "7",
            school: "Mount Litera Zee School- Baharampur",
            image: girlStudent2,
            acheivement: "Academic Excellence Award",
        },
        {
            id: 3,
            title: "Samia Sultana",
            content: "9",
            school: "St. Pauls",
            image: girlStudent3,
            acheivement: "Best in Science - Grade 9",
        },
        {
            id: 4,
            title: "Anusha Adhikari",
            content: "6",
            school: "St. Pauls",
            image: girlStudent4,
            acheivement: "Star Performer - Grade 6",
        },
        {
            id: 5,
            title: "Zainab Noor",
            content: "5",
            school: "Mount Litera Zee School- Baharampur",
            image: girlStudent5,
            acheivement: "Rising Star Award",
        },
    ];

    const [activeIndex, setActiveIndex] = useState(0);

    // Calculate if we're at the start or end
    const isAtStart = activeIndex === 0;
    const isAtEnd = activeIndex >= cards.length - 2;

    const handleNext = () => {
        if (!isAtEnd) {
            setActiveIndex((prevIndex) => prevIndex + 1);
        }
    };
    const handlePrev = () => {
        if (!isAtStart) {
            setActiveIndex((prevIndex) => prevIndex - 1);
        }
    };

    const calculateWidth = (earnedPoints) => {
        if (earnedPoints === 0) return "0%";
        if (earnedPoints > 0 && earnedPoints < 750) return "10%";
        if (earnedPoints === 750) return "15%";
        if (earnedPoints > 750 && earnedPoints < 1500) return "30%";
        if (earnedPoints === 1500) return "35%";
        if (earnedPoints > 1500 && earnedPoints < 2000) return "50%";
        if (earnedPoints === 2000) return "55%";
        if (earnedPoints > 2000 && earnedPoints < 2200) return "69%";
        if (earnedPoints >= 2200) return "82%";
        return "82%";
    };

    const width = calculateWidth(earnedPoints);

    return (
        <>
            <SideBar />
            <ProfileBar />
            <Box
                sx={{
                    flexGrow: 1,
                    position: "relative",
                    width: "calc(100vw - 260px)",
                    padding: "20px 20px",
                    height: "100vh",
                    overflowY: "scroll",
                    left: "260px",
                    backgroundColor: "#F8F9FD",
                }}
            >
                <Stack direction="column" spacing={2}>
                    <Grid2 container spacing={2} justifyContent="center">
                        {/* <Grid2 size={4} height='250px' bgcolor='white' borderRadius='12px' border='1px solid #F2F2F2'>
                        </Grid2> */}
                        <Grid2
                            size="grow"
                            height="250px"
                            bgcolor="white"
                            borderRadius="12px"
                            border="1px solid #F2F2F2"
                        >
                            {/* <Stack padding='20px' spacing={1}>
                                <Stack direction='row' alignItems='center' justifyContent='space-between'>
                                    <Typography variant='h4'>Progress</Typography>
                                </Stack>
                                <Divider />
                                <Stack sx={{ padding: '10px 0', width: '100%' }} spacing={1.5}>
                                    <Typography variant='h5' margin='0'>Badge Progress</Typography>
                                    <Stepper activeStep={activeStep} alternativeLabel connector={<CustomConnector />}>
                                        {steps.map((label, index) => (
                                            <Step key={label}>
                                                <StepLabel StepIconComponent={ImageStepIcon} StepIconProps={{ icon: index + 1 }} sx={{
                                                    '& .MuiStepIcon-root': { // Target the icon container
                                                        width: 40,
                                                        height: 40,
                                                    },
                                                    '& .MuiStepIcon-text': { // Hide default number (if needed)
                                                        display: 'none',
                                                    },
                                                }}>{label}</StepLabel>
                                            </Step>
                                        ))}
                                    </Stepper>
                                </Stack>
                                <Stack spacing={1.5}>
                                    <Typography variant='h5'>Course Progress</Typography>
                                    <BorderLinearProgress variant="determinate" value={50} />
                                </Stack>
                            </Stack> */}
                            <Stack
                                padding="20px"
                                sx={{ width: "100%" }}
                                spacing={2}
                            >
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                >
                                    <Typography variant="h4">
                                        Achievements
                                    </Typography>
                                    {/* <Typography variant='body2'>See All</Typography> */}
                                </Stack>
                                <Divider />
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: 1,
                                    }}
                                >
                                    <IconButton
                                        onClick={handlePrev}
                                        disabled={isAtStart}
                                        sx={{ alignSelf: "center" }}
                                    >
                                        <ChevronLeft fontSize="large" />
                                    </IconButton>

                                    <Box
                                        sx={{
                                            width: "100%",
                                            overflow: "hidden",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: "flex",
                                                gap: "10px",
                                                transform: `translateX(-${
                                                    activeIndex * 50
                                                }%)`,
                                                transition:
                                                    "transform 0.5s ease",
                                            }}
                                        >
                                            {cards.map((card) => (
                                                <Box
                                                    key={card.id}
                                                    sx={{
                                                        height: "154px",
                                                        flex: "0 0 calc(50% - 9px)",
                                                        border: "1px solid #F2F2F2",
                                                        borderRadius: "12px",
                                                        padding: "0",
                                                        boxShadow: "none",
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            gap: "10px",
                                                            padding: "10px",
                                                            height: "100%",
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                flexBasis:
                                                                    "40%",
                                                            }}
                                                        >
                                                            <img
                                                                height="100%"
                                                                width="100%"
                                                                src={card.image}
                                                                style={{
                                                                    objectFit:
                                                                        "cover",
                                                                    borderRadius:
                                                                        "6px",
                                                                }}
                                                            />
                                                        </Box>
                                                        <Box
                                                            height="100%"
                                                            display="flex"
                                                            flexDirection="column"
                                                            justifyContent="space-between"
                                                            gap="3px"
                                                        >
                                                            {/* Title, Content, and School Section */}
                                                            <Box
                                                                height="fit-content"
                                                                display="flex"
                                                                flexDirection="column"
                                                                justifyContent="center"
                                                                gap="3px"
                                                            >
                                                                <Typography
                                                                    variant="h5"
                                                                    component="div"
                                                                >
                                                                    {card.title}
                                                                </Typography>
                                                                <Typography variant="body2">
                                                                    Class:{" "}
                                                                    {
                                                                        card.content
                                                                    }
                                                                </Typography>
                                                                <Typography variant="body2">
                                                                    {
                                                                        card.school
                                                                    }
                                                                </Typography>
                                                            </Box>
                                                            {/* Achievement Section */}
                                                            <Box
                                                                height="fit-content"
                                                                display="flex"
                                                                flexDirection="column"
                                                                justifyContent="center"
                                                                gap="3px"
                                                            >
                                                                <Typography variant="h5">
                                                                    Achievements
                                                                </Typography>
                                                                <Typography variant="body2">
                                                                    {
                                                                        card.acheivement
                                                                    }
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>

                                    <IconButton
                                        onClick={handleNext}
                                        disabled={isAtEnd}
                                        sx={{ alignSelf: "center" }}
                                    >
                                        <ChevronRight fontSize="large" />
                                    </IconButton>
                                </Box>
                            </Stack>
                        </Grid2>
                        <Grid2
                            size="200px"
                            height="250px"
                            bgcolor="white"
                            borderRadius="12px"
                            border="1px solid #F2F2F2"
                        >
                            {bannerData.studentBannerData?.length > 0 ? (
                                bannerData.studentBannerData.filter(
                                    (e) =>
                                        (e.bannerPageLocation === "Right_Sidebar" ||
                                        e.bannerPageLocation === "Right Sidebar") &&
                                        e.bannerStatus === true
                                )[0] && (
                                    <a
                                        rel="noopener noreferrer"
                                        href={
                                            bannerData.studentBannerData.filter(
                                                (e) =>
                                                    (e.bannerPageLocation ===
                                                        "Right_Sidebar" ||
                                                    e.bannerPageLocation ===
                                                        "Right Sidebar") &&
                                                    e.bannerStatus === true
                                            )[0]?.bannerLink
                                        }
                                        target="_blank"
                                    >
                                        <img
                                            height="250px"
                                            width="100%"
                                            style={{
                                                objectFit: "cover",
                                                overflow: "none",
                                                borderRadius: "12px",
                                            }}
                                            src={
                                                API_BannerURL +
                                                bannerData.studentBannerData.filter(
                                                    (e) =>
                                                        (e.bannerPageLocation ===
                                                            "Right_Sidebar" ||
                                                        e.bannerPageLocation ===
                                                            "Right Sidebar") &&
                                                        e.bannerStatus === true
                                                )[0]?.bannerPath
                                            }
                                            alt="Banner"
                                        />
                                    </a>
                                )
                            ) : null}
                        </Grid2>
                    </Grid2>
                    <Grid2 container spacing={2} justifyContent="center">
                        {/* Badge Progress Container */}
                        <Grid2
                            size={6}
                            bgcolor="white"
                            borderRadius="12px"
                            border="1px solid #F2F2F2"
                        >
                            <Stack
                                padding="20px"
                                sx={{ width: "100%" }}
                                spacing={2}
                            >
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                >
                                    <Typography variant="h4">
                                        Badge Progress
                                    </Typography>
                                    {/* <Typography variant='body2'>See All</Typography> */}
                                </Stack>
                                <Divider />
                                {/* badge progress container */}
                                <Box
                                    sx={{
                                        width: "100%",
                                        display: "grid",
                                        gridTemplateColumns: "repeat(5, 1fr)",
                                        columnGap: 1,
                                        position: "relative",
                                        "&:before": {
                                            content: '""',
                                            position: "absolute",
                                            width: "80%",
                                            bgcolor: "#F8F8F8",
                                            height: "3px",
                                            left: "10%",
                                            top: "37.5%",
                                        },
                                        "&:after": {
                                            content: '""',
                                            position: "absolute",
                                            zIndex: 2,
                                            width: width,
                                            bgcolor: "#F85006",
                                            // opacity: "50%",
                                            height: "3px",
                                            left: "10%",
                                            top: "37.5%",
                                            boxShadow:
                                                "0 0 10px #F85006, 0 0 20px #F85006",
                                        },
                                    }}
                                >
                                    {badgeObj.map((badge, idx) => (
                                        <Box
                                            key={idx}
                                            sx={{
                                                position: "relative",
                                                zIndex: 10,
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            {/* lock and unlock icon display */}
                                            <Box
                                                sx={{
                                                    position: "absolute",
                                                    top: -5,
                                                    right: 15,
                                                    rotate: "10deg",
                                                    zIndex: 10,
                                                    aspectRatio: "1/1",
                                                    width: "20px",
                                                }}
                                            >
                                                {/* Background Image Blur */}
                                                <img
                                                    src={
                                                        badge.points <=
                                                        earnedPoints
                                                            ? "/unlock.svg"
                                                            : "/lock.svg"
                                                    }
                                                    style={{
                                                        width: "100%",
                                                        height: "auto",
                                                        filter: "blur(15px) brightness(1.75)",
                                                    }}
                                                />
                                                {/* Front Image */}
                                                <img
                                                    src={
                                                        badge.points <=
                                                        earnedPoints
                                                            ? "/unlock.svg"
                                                            : "/lock.svg"
                                                    }
                                                    style={{
                                                        width: "100%",
                                                        height: "auto",
                                                        position: "absolute",
                                                        inset: 0,
                                                        filter: "brightness(1.1)",
                                                    }}
                                                />
                                            </Box>
                                            {/* Main Badge icon display */}
                                            <Box
                                                key={idx}
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "5px",
                                                    filter:
                                                        badge.points <=
                                                        earnedPoints
                                                            ? "grayscale(0%)"
                                                            : "grayscale(100%) sepia(60%) hue-rotate(-50deg) saturate(300%)",
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        position: "relative",
                                                        width: "fit-content",
                                                        display: "flex",
                                                        justifyContent:
                                                            "center",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    {/* Background Image Blur */}
                                                    <img
                                                        src={badge.comp}
                                                        style={{
                                                            width: "80%",
                                                            aspectRatio: "1/1",
                                                            height: "auto",
                                                            filter: "blur(15px)",
                                                        }}
                                                    />
                                                    {/* Front Image */}
                                                    <img
                                                        src={badge.comp}
                                                        style={{
                                                            width: "80%",
                                                            aspectRatio: "1/1",
                                                            height: "auto",
                                                            position:
                                                                "absolute",
                                                            inset: 0,
                                                            margin: "auto",
                                                        }}
                                                    />
                                                </Box>
                                            </Box>

                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    width: "100%",
                                                    textAlign: "center",
                                                    fontWeight: 700,
                                                }}
                                            >
                                                {badge.points}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                                <Stack
                                    justifyContent="space-between"
                                    alignItems="center"
                                    direction="row"
                                >
                                    <Typography
                                        sx={{
                                            borderRadius: "6px",
                                            border: "1px solid #F2F2F2",
                                            padding: "10px",
                                        }}
                                    >
                                        Earned Points:{" "}
                                        <b style={{ color: "#F85006" }}>
                                            {earnedPoints >= 2200
                                                ? 2200
                                                : earnedPoints}
                                        </b>
                                    </Typography>
                                    {/* <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => {
                                            navigate("/StudentDashboard/StudentProfile")
                                        }}
                                    >
                                        Redeem Points
                                    </Button> */}
                                </Stack>
                            </Stack>
                        </Grid2>
                        {/* My Course Container */}
                        <Grid2
                            size={6}
                            bgcolor="white"
                            borderRadius="12px"
                            border="1px solid #F2F2F2"
                        >
                            <Stack
                                padding="20px"
                                spacing={2}
                                height="100%"
                                // height="250px"
                            >
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                >
                                    <Typography variant="h4">
                                        My Courses
                                    </Typography>

                                    {/* see all typo variant */}
                                    {courseData?.studentCourseMaster?.length > 0
                                        ? courseData.studentCourseMaster.filter(
                                              (e) =>
                                                  e.subject ===
                                                  userData?.className
                                          ).length > 0 && (
                                              <Typography
                                                  variant="body1"
                                                  onClick={() => {
                                                      navigate(
                                                          "/StudentDashboard/CourseList"
                                                      );
                                                  }}
                                                  color="secondary"
                                                  sx={{
                                                      cursor: "pointer",
                                                  }}
                                              >
                                                  See All
                                              </Typography>
                                          )
                                        : null}

                                    {/* see all button variant */}
                                    {/* <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => {
                                            navigate(
                                                "/StudentDashboard/CourseList"
                                            );
                                        }}
                                    >
                                        See All
                                    </Button> */}
                                </Stack>
                                <Divider />
                                <Grid2
                                    container
                                    height="100%"
                                    direction="column"
                                    spacing={2}
                                >
                                    {Object.keys(courseData.studentCourseMaster)
                                        .length === 0 ? (
                                        <Typography
                                            variant="subtitle1"
                                            color="secondary"
                                        >
                                            No Course Data available
                                        </Typography>
                                    ) : courseData?.studentCourseMaster
                                          ?.length > 0 ? (
                                        courseData.studentCourseMaster
                                            .filter(
                                                (e) =>
                                                    e.subject ===
                                                    userData?.className
                                            )
                                            .slice(0, 1)
                                            .map((course, index) => (
                                                <Grid2
                                                    sx={{
                                                        cursor: "pointer",
                                                    }}
                                                    size={12}
                                                    container
                                                    direction="row"
                                                    padding="10px"
                                                    border="1px solid #F3F0EC"
                                                    borderRadius="6px"
                                                    // height="145px"
                                                    height="fit-content"
                                                    key={index}
                                                    onClick={() =>
                                                        setCourseInternalData(
                                                            course
                                                        )
                                                    }
                                                >
                                                    <Grid2 size={5}>
                                                        <img
                                                            style={{
                                                                // height: "100%",
                                                                width: "100%",
                                                                // maxHeight: "170px",
                                                                // maxWidth:
                                                                //     "220px",
                                                                aspectRatio:
                                                                    "16/9",
                                                                objectFit:
                                                                    "cover",
                                                                borderRadius:
                                                                    "6px",
                                                                objectPosition:
                                                                    "top",
                                                            }}
                                                            src={
                                                                API_courseURL +
                                                                course.courseThumbnailImagepath
                                                            }
                                                            alt={
                                                                course.courseName
                                                            }
                                                        />
                                                    </Grid2>
                                                    <Grid2 size={7}>
                                                        <Typography variant="h5">
                                                            {course.courseName}
                                                        </Typography>
                                                        <Typography variant="caption">
                                                            {course.courseCode}
                                                        </Typography>
                                                    </Grid2>
                                                </Grid2>
                                            ))
                                    ) : null}
                                    {/* old logic */}
                                    {/* {courseData?.studentCourseMaster?.length > 0 ?
                                        courseData.studentCourseMaster.filter((e) => e.subject === userData?.className).slice(0, 1).map((course, index) => (
                                            <Grid2
                                                sx={{ cursor: 'pointer' }}
                                                size={12}
                                                container
                                                direction='row'
                                                padding='10px'
                                                border='1px solid #F3F0EC'
                                                borderRadius='6px'
                                                height='145px'
                                                key={index}
                                                onClick={() => setCourseInternalData(course)}
                                            >
                                                <Grid2 size={5}>
                                                    <img
                                                        style={{
                                                            height: '100%',
                                                            width: '100%',
                                                            maxHeight: '123px',
                                                            maxWidth: '220px',
                                                            objectFit: 'cover',
                                                            borderRadius: '6px',
                                                            objectPosition: 'top',
                                                        }}
                                                        src={API_courseURL + course.courseThumbnailImagepath}
                                                        alt={course.courseName}
                                                    />
                                                </Grid2>
                                                <Grid2 size={7}>
                                                    <Typography variant='h5'>{course.courseName}</Typography>
                                                    <Typography variant='caption'>{course.courseCode}</Typography>
                                                </Grid2>
                                            </Grid2>
                                        )) : null
                                    } */}
                                </Grid2>
                            </Stack>
                        </Grid2>
                    </Grid2>
                    <Grid2 container spacing={2} justifyContent="center">
                        <Grid2
                            size={12}
                            height="auto"
                            width="100%"
                            bgcolor="white"
                            borderRadius="12px"
                            border="1px solid #F2F2F2"
                        >
                            {bannerData.studentBannerData?.length > 0 ? (
                                bannerData.studentBannerData.filter(
                                    (e) =>
                                        (e.bannerPageLocation === "Bottom" ||
                                        e.bannerPageLocation === "Middle Lower") &&
                                        e.bannerStatus === true
                                )[0] && (
                                    <a
                                        rel="noopener noreferrer"
                                        href={
                                            bannerData.studentBannerData.filter(
                                                (e) =>
                                                    (e.bannerPageLocation ===
                                                        "Bottom" ||
                                                    e.bannerPageLocation ===
                                                        "Middle Lower") &&
                                                    e.bannerStatus === true
                                            )[0]?.bannerLink
                                        }
                                        target="_blank"
                                    >
                                        <img
                                            height="100px"
                                            width="100%"
                                            style={{
                                                objectFit: "cover",
                                                overflow: "none",
                                                borderRadius: "12px",
                                            }}
                                            src={
                                                API_BannerURL +
                                                bannerData.studentBannerData.filter(
                                                    (e) =>
                                                        (e.bannerPageLocation ===
                                                            "Bottom" ||
                                                        e.bannerPageLocation ===
                                                            "Middle Lower") &&
                                                        e.bannerStatus === true
                                                )[0]?.bannerPath
                                            }
                                            alt="Banner"
                                        />
                                    </a>
                                )
                            ) : null}
                        </Grid2>
                    </Grid2>
                    <Grid2 container spacing={2} justifyContent="center">
                        <Grid2
                            size={8}
                            height="400px"
                            bgcolor="white"
                            borderRadius="12px"
                            border="1px solid #F2F2F2"
                        >
                            <Stack padding="20px" spacing={2}>
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                >
                                    <Typography variant="h4">
                                        Top 3 Projects
                                    </Typography>
                                </Stack>
                                <Divider />
                                <Box
                                    display="flex"
                                    width="100%"
                                    height="305px"
                                    gap="20px"
                                    justifyContent="start"
                                >
                                    {/* Checking if the project are present if not than display
                                    "No Data Available" */}
                                    {Object.keys(ProjectsData).length === 0 ? (
                                        <Typography
                                            variant="subtitle1"
                                            color="secondary"
                                        >
                                            No Project Data Available
                                        </Typography>
                                    ) : (
                                        ProjectsData?.filter(
                                            (e) => e.status === "Approved"
                                        )
                                            .slice(0, 3)
                                            .map((project, index) => (
                                                <Box
                                                    width="33%"
                                                    display="flex"
                                                    flexDirection="column"
                                                    justifyContent="space-between"
                                                    key={index}
                                                    sx={{
                                                        border: "1px solid #F2F2F2",
                                                        borderRadius: "6px",
                                                        padding: "10px",
                                                    }}
                                                >
                                                    <img
                                                        height="100px"
                                                        width="100%"
                                                        style={{
                                                            objectFit: "cover",
                                                            borderRadius: "6px",
                                                        }}
                                                        src={
                                                            API_courseURL +
                                                            project
                                                                .mediaFiles[0]
                                                                .projectMediaPath
                                                        }
                                                    />
                                                    <Typography variant="subtitle2">
                                                        Class:{" "}
                                                        {project.className}
                                                    </Typography>
                                                    <Typography variant="h5">
                                                        {project.projectName}
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        {project.studentName}
                                                    </Typography>
                                                    <Button
                                                        color="secondary"
                                                        variant="outlined"
                                                        onClick={() => {
                                                            navigate(
                                                                `/project/${project.projectSubmissionId}`
                                                            );
                                                        }}
                                                    >
                                                        View Project
                                                    </Button>
                                                </Box>
                                            ))
                                    )}
                                </Box>
                                {/* Project content would go here */}
                                {/* <Stack spacing={2}>
                                    {loading ? (
                                        <Box display="flex" justifyContent="center" alignItems="center" height="200px">
                                            <CircularProgress />
                                        </Box>
                                    ) : (
                                        ProjectsData?.slice(0, 5).map((projects, index) => (
                                            <Stack
                                                key={projects.projectSubmissionId || index}
                                                direction="row"
                                                alignItems="center"
                                                spacing={2}
                                                sx={{
                                                    padding: '8px',
                                                    borderRadius: '6px'
                                                }}
                                            >
                                                <Avatar
                                                    src={ProjectsImages[index + 1]}
                                                    sx={{ width: 32, height: 32 }}
                                                />
                                                <Typography variant="body2" sx={{ flexGrow: 1 }}>
                                                    {projects.projectName || `Student ${index + 1}`}
                                                </Typography>
                                                <Typography variant="body2" color="primary">
                                                    {projects.status || 0}
                                                </Typography>
                                            </Stack>
                                        ))
                                    )}
                                </Stack> */}
                            </Stack>
                        </Grid2>
                        <Grid2
                            size={4}
                            height="400px"
                            bgcolor="white"
                            borderRadius="12px"
                            border="1px solid #F2F2F2"
                        >
                            <Stack padding="20px" spacing={2}>
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                >
                                    <Typography variant="h4">
                                        Weekly Leaderboard
                                    </Typography>
                                </Stack>
                                <Divider />
                                <Stack spacing={2}>
                                    {leaderboardLoading ? (
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            height="200px"
                                        >
                                            <CircularProgress />
                                        </Box>
                                    ) : leaderboardError ? (
                                        <Typography
                                            color="error"
                                            variant="body2"
                                        >
                                            Error loading leaderboard:{" "}
                                            {leaderboardError}
                                        </Typography>
                                    ) : (
                                        leaderboardData?.map(
                                            (student, index) => (
                                                <Stack
                                                    key={
                                                        student.userId || index
                                                    }
                                                    direction="row"
                                                    alignItems="center"
                                                    spacing={2}
                                                    sx={{
                                                        backgroundColor:
                                                            student.userId ===
                                                            userData?.userId
                                                                ? "#cfd3e9"
                                                                : "transparent",
                                                        padding: "8px",
                                                        borderRadius: "6px",
                                                    }}
                                                >
                                                    <Avatar
                                                        src={
                                                            leaderboardImages[
                                                                index + 1
                                                            ]
                                                        }
                                                        sx={{
                                                            width: 32,
                                                            height: 32,
                                                        }}
                                                    />
                                                    <Typography
                                                        variant="body2"
                                                        sx={{ flexGrow: 1 }}
                                                    >
                                                        {student.userName ||
                                                            `Student ${
                                                                index + 1
                                                            }`}
                                                    </Typography>
                                                    <Typography
                                                        variant="body2"
                                                        color="primary"
                                                    >
                                                        {student.totalEarnedPoint >=
                                                        2200
                                                            ? 2200
                                                            : student.totalEarnedPoint}{" "}
                                                        pts
                                                    </Typography>
                                                </Stack>
                                            )
                                        )
                                    )}
                                </Stack>
                            </Stack>
                        </Grid2>
                    </Grid2>
                </Stack>
                <Outlet />
            </Box>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={() => setSnackbarOpen(false)}
            >
                <MuiAlert
                    onClose={() => setSnackbarOpen(false)}
                    severity="error"
                    sx={{ width: "100%" }}
                >
                    Add your Parent Information
                </MuiAlert>
            </Snackbar>
        </>
    );
};

export default DashContent;
